import { homePhotoProps, HOME_GRID_SIZES } from "@/lib/homePhotoProps";
import { Link } from "react-router-dom";

import ProjectImage from "@/components/ProjectImage";
import { caseStudies } from "@/data/caseStudies";
import glenRockHomePhoto from "@/assets/projects/limewash-dining-room-table-glen-rock-nj.webp.asset.json";
import newBrunswickHomePhoto from "@/assets/fluted-plaster-fireplace-new-brunswick-nj.webp.asset.json";
const selectedIds = ["cs-franklin-lakes-limewash-fireplaces", "cs-cedar-grove", "cs-glen-rock-limewash-dining-entry", "cs-franklin-lakes", "cs-new-brunswick", "cs-coffiyeh"];
/** Homepage-only lead photos for cards whose project page keeps its original set. */
const homeSrcOverrides: Record<string, string> = {
  "cs-glen-rock-limewash-dining-entry": glenRockHomePhoto.url,
  "cs-new-brunswick": newBrunswickHomePhoto.url,
};
const projects = selectedIds.flatMap((id) => {
  const project = caseStudies.find((item) => item.id === id);
  return project?.src ? [{ ...project, src: homeSrcOverrides[id] ?? project.src, position: "", finish: project.finish }] : [];
});

const HomeRecentProjects = () => (
  <section className="bg-background text-foreground">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-14 md:py-20">
      {/* Header */}
      <div className="flex items-end justify-between gap-6 border-b border-foreground/10 pb-5">
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-clay mb-3">Portfolio</p>
          <h2 className="font-body uppercase text-xl md:text-2xl tracking-[0.12em] font-light">
            Selected Specialty-Finish Projects
          </h2>
        </div>
        <Link
          to="/gallery/specialty-finishes/"
          className="hidden sm:inline-block text-[10px] uppercase tracking-[0.2em] border-b border-clay pb-1 hover:text-clay transition-colors"
        >
          Explore Our Plaster Work
        </Link>
      </div>

      {/* Compact grid — up to 4 per row */}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
        {projects.map((project) => (
          <Link key={project.id} to={project.to} className="group block">
            <div className="aspect-[4/3] overflow-hidden bg-muted">
              <ProjectImage
                src={project.src} {...homePhotoProps(project.src, HOME_GRID_SIZES)}
                alt={project.alt}
                className={`w-full h-full object-cover ${(project as { position?: string }).position ?? ""} transition-transform duration-700 group-hover:scale-[1.04]`}
              />
            </div>

            <div className="mt-4 border-t border-clay pt-3">
              <h3 className="text-sm font-light tracking-[0.04em] mb-3 transition-colors group-hover:text-clay">
                {project.title}
              </h3>
              <div className="space-y-2">
                <div>
                  <span className="block text-[9px] uppercase tracking-[0.2em] text-muted-foreground mb-0.5">
                    Location
                  </span>
                  <span className="block text-[11px] uppercase tracking-[0.1em]">{project.location}</span>
                </div>
                <div>
                  <span className="block text-[9px] uppercase tracking-[0.2em] text-muted-foreground mb-0.5">
                    Finish
                  </span>
                  <span className="block text-[11px] uppercase tracking-[0.1em]">{project.finish}</span>
                </div>
              </div>
              <span className="mt-3 inline-block text-[10px] uppercase tracking-[0.2em] border-b border-clay pb-0.5 group-hover:text-clay transition-colors">
                View Project
              </span>
            </div>
          </Link>
        ))}
      </div>

      {/* Mobile view-all */}
      <div className="mt-12 sm:hidden text-center">
        <Link
          to="/gallery/specialty-finishes/"
          className="inline-block text-[10px] uppercase tracking-[0.2em] border-b border-clay pb-1"
        >
          Explore Our Plaster Work
        </Link>
      </div>
    </div>
  </section>
);

export default HomeRecentProjects;
